import { useBooleanFlagValue } from '@openfeature/react-sdk';

/** UFF flag, shared with ap_web (PaacSettingsController and the settings sidebar). */
export const PLANNED_ACTUAL_AMOUNT_CHECK_FLAG = 'planned-actual-amount-check';

/** Gate for the planned vs actual amount check (予定実績チェック) settings page. */
export const usePlannedActualAmountCheckFlag = (): boolean =>
  useBooleanFlagValue(PLANNED_ACTUAL_AMOUNT_CHECK_FLAG, false);
